import { Injectable } from '@angular/core';
import { firstValueFrom, Subscription } from 'rxjs';

import { AppWizardState, WizardStep } from '../models/app-product-state';
import { Offer } from '../models/product';
import { offerCreateDefault, offerHeaderIdCreate } from '../models/product-utils';

import { OfferService } from './offer.api.service';
import { OfferWizardDb } from './product.database';

@Injectable({ providedIn: 'root' })
export class AppWizardService {
	previousUrl?: string;
	urlData: string[] = [];
	backViewSubscription?: Subscription;
	private state: AppWizardState;
	constructor(
		private readonly offerService: OfferService,
		private readonly db: OfferWizardDb
	) {
		const defaultOffer = offerCreateDefault();
		this.state = new AppWizardState(defaultOffer, defaultOffer);
	}

	getState() {
		return this.state;
	}

	getStateOfferForm() {
		return this.state.offer.form;
	}

	async checkWizardStateValidity(stepIndex: WizardStep) {
		// if user starts wizard via a direct URL (i.e. without going through "new", "edit", or "copy" offer)
		// then, if no offer in cache, a new offer is created
		// anyway the wizard is launched from the beginning
		// while substituating the initial global state (cf. locationService.back)
		this.state.stepIndex = stepIndex;
		if (this.state.isValid) {
			return true;
		}
		if (this.state.exiting) {
			this.state.exiting = false;
			return true;
		}
		return this.restoreCachedOffer();
	}

	async actionExitWizard() {
		const defaultOffer = offerCreateDefault();
		this.initOffer(defaultOffer, defaultOffer);
		await this.db.removeOffer();
		return true;
	}

	private async restoreCachedOffer() {
		const offer = await this.db.getOffer();
		if (!offer) {
			return false;
		}
		const lastSavedOffer =
			offer.header.id === undefined
				? offerCreateDefault() // not saved already, then take default as reference
				: await firstValueFrom(this.offerService.getOffer(offerHeaderIdCreate(offer.header), true, 'NONE'));
		this.initOffer(offer, lastSavedOffer);
		return true;
	}

	private initOffer(offer: Offer, lastSavedOffer: Offer) {
		this.state = new AppWizardState(offer, lastSavedOffer);
		this.state.isValid = true;
	}
}
